import { initInlineEdit, isEditingInline } from '@/views/pages/campaign/components/edit-quick-field/constants';
import { validateField } from '@/utils/validate_v2';
import { masterMethods, campaignMethods } from '@/state/helpers';
import { campaignStatus } from '@/config/var-common';
import { initValidateEditQuickly } from '@/views/pages/campaign/components/edit-quick-field/constants';
import { showMessage } from '@/utils/messages';
import { onHandleShowConfirm } from '@/utils/handlers';

export default {
    data() {
        return {
            inlineEdit: initInlineEdit(),
            isProcessingInline: false,
            listPIC: [],
            listSaleStaff: [],
            isDisabledEditListStatus: false,
            isVisibledEdit: false
        };
    },
    methods: {
        ...masterMethods,
        ...campaignMethods,
        isEditingInline,

        handleValidateFieldInline(valueField, configField) {
            validateField(valueField, configField);
        },

        onHandleCancelInlineEdit() {
            this.inlineEdit = initInlineEdit();
            this.isDisabledEditListStatus = false;
        },
        async onHandleSaveInlineEdit(row, field, updateCallback) {
            if (this.isProcessingInline) return;
            validateField(this.inlineEdit.value, this.inlineEdit.config);
            if (this.inlineEdit.config.error) return;
            this.isProcessingInline = true;
            try {
                const newValue = this.inlineEdit.value;
                const success = await updateCallback(row, field, newValue);
                if (success) {
                    this.onHandleCancelInlineEdit();
                    if (this.refreshTable) {
                        this.refreshTable();
                    } else if (this.getList) {
                        this.getList();
                    }
                    this.$emit('refresh');
                }
            } catch (error) {
                console.error('Inline edit save error:', error);
            } finally {
                this.isProcessingInline = false;
            }
        },

        onHandleBuildPayload(field, newValue) {
            const payload = {};
            payload[field] = newValue?.id !== undefined ? newValue.id : newValue;
            return payload;
        },

        async getListCommonUserInline(row) {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.listPIC = dataRes['admin_and_instructor']; //1,3
                this.listSaleStaff = dataRes['sale']; //2
                const subPersons = row?.responsible_sub_persons;
                if (subPersons?.length > 0) {
                    const disabledIds = new Set(subPersons.map((p) => p?.id));
                    this.listPIC.forEach((option) => {
                        if (disabledIds.has(option?.id)) {
                            option.$isDisabled = true;
                        }
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        async onHandleStartInlineEdit(row, field) {
            if (this.isProcessingInline) return;
            if (this.inlineEdit.rowId !== null) {
                this.onHandleCancelInlineEdit();
            }
            let value = null;
            let config = {};
            switch (field) {
                case 'progress_status':
                    // eslint-disable-next-line no-case-declarations
                    const progressStatus = row.progress_status?.id ? row.progress_status.id : row.progress_status;
                    value = campaignStatus.find((item) => item.id === progressStatus);
                    break;
                case 'person_in_charge_id':
                    value = row.person_in_charge || null;
                    await this.getListCommonUserInline(row);
                    break;
                case 'sale_staff_id':
                    value = row.sale_staff || null;
                    await this.getListCommonUserInline(row);
                    break;
                case 'inquiries':
                    value = row.campaign_content_other?.inquiries || '';
                    break;
                default:
                    value = row[field];
                    break;
            }
            let initialValidData = initValidateEditQuickly();
            config = initialValidData[field];
            this.inlineEdit = initInlineEdit({
                value,
                config,
                rowId: row.id,
                field
            });
            if (this.handleToggleEditStatus) {
                this.handleToggleEditStatus();
            }
            this.isVisibledEdit = false;
            this.isDisabledEditListStatus = true;
        },

        async onHandleSaveCampaignInline(row, field, forceRegister = false) {
            await this.onHandleSaveInlineEdit(row, field, async (row, field, newValue) => {
                const payload = this.onHandleBuildPayload(field, newValue);
                payload.force_register = forceRegister;
                const dataRes = await this.updateQuickCampaign({ id: row.id, payload });
                if (dataRes?.code === 200) {
                    showMessage(dataRes.code, this.$bvToast, 'キャンペーンが更新されました。');
                    this.isDisabledEditListStatus = false;
                    return true;
                } else if (dataRes?.message === 'campaign.duplicate_name') {
                    onHandleShowConfirm({
                        title: '',
                        text: '同一のキャンペーン名称があるが登録しますか。'
                    }).then((value) => {
                        if (value) {
                            this.onHandleSaveCampaignInline(row, field, true);
                        }
                    });
                    return false;
                }
                showMessage(dataRes?.code, this.$bvToast, this.$t(dataRes?.message));
                return false;
            });
        }
    }
};
